import { Component } from "react";

/** Catches render errors so a broken section never blanks the whole site. */
export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="section" style={{ textAlign: "center" }}>
          <div className="container" style={{ display: "grid", gap: 16, justifyItems: "center" }}>
            <div className="kicker">Something went wrong</div>
            <h1 className="h2">This page hit an unexpected error.</h1>
            <p className="lede" style={{ maxWidth: "56ch" }}>
              Refresh to try again. If it keeps happening, let us know at contact@sigvion.com.
            </p>
            <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
